import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MarkunreadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"markunread"}/>
}
